<template>
    <div>
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Forum Details</h1>
                    </div>
                </div>
            </div>
        </section>
        <div class="internal-page-main-section faq-section-main forum-main col-12">
            <div class="container">
                <div class="MainForum MainForumDetails">
                    <div class="ForumPage ForumPage0">
                        <div class="row col-12">
                            <div class="col-12 paddingleft0">
                                <div id="alertError" class="mt-3 alert alert-danger" style="display: none;">
                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                    <strong id="errorMsg" class="error"></strong>
                                </div>
                            </div>
                        </div>
                        <div v-if="questionData.id != 0" class="ForumListing">
                            <div class="ForumQue ForumQueBorderNone">
                                {{questionData.question}}
                            </div>
                            <div v-if="addNewComment == true" class="mt-3 ForumQue-top-container">
                                <div class="ForumQueActions">
                                    <div class="col-12 paddingleft0">
                                        <textarea v-model="userComment" class="form-control" id="userComment" placeholder="Write Comment"></textarea>
                                        <div class="requiredstar">*</div>
                                        <font class="text-danger">{{userCommentError}}</font>
                                    </div>
                                    <div class="row mt-2 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <button id="addComment" class="btn btn-primary hrv-sweep-to-right-blue" v-on:click.prevent="addComment(questionData.id)">Submit</button>
                                            <button id="CancelComment" class="btn btn-primary hrv-sweep-to-right-red" v-on:click.prevent="clickAddNewComment()">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ForumQue-top-container">
                                <div class="ForumQueActions">
                                    <a title="Comment on this Question" v-if="addNewComment == false" href="javascript:void(0);" v-on:click.prevent="clickAddNewComment()" class="forum_edit_icon hvr-sweep-to-right-blue">
                                        <img src="/static/images/edit_icon.png"> Comment
                                    </a>
                                </div>
                            </div>
                            <div class="ForumQue-top-container ForumQue-Image-container">
                                <template v-for="(imgObj, index) in questionData.immages">
                                    <a title="" :key="'images_' + index" class="image-zoom example-image-link" :href="imgObj.images_path" rel="prettyPhoto[gallery]" data-lightbox="question-images" data-title="">
                                       <img :src="imgObj.images_path"/>
                                    </a>
                                </template>
                            </div>
                            <!----> 
                            <template v-for="(ansObj, index) in questionCommentData">
                                <div class="que-comment" :key="ansObj.id">
                                    <div :key="'comment_' + index" class="ForumQue-top-container">
                                        <strong>{{ansObj.created_by}}</strong>
                                        <span>{{utcToLocal(ansObj.created_at, 'hh:mm A MMM D, YYYY')}}</span>
                                        <p>{{ansObj.comment}}</p>
                                    </div>
                                </div>
                            </template>
                            <div :key="'load_comment_' + index" class="ForumQue-Details">
                                <section v-show="totalComments > questionCommentData.length" class="container load_more_container pr-0">
                                    <button class="btn btn-danger deleteMedia hvr-sweep-to-right-red" v-on:click.prevent="getComments(questionData.id)">
                                        Load More Comments
                                    </button>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import index from "../router";
    import EventBus from "./event-bus";
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    var self;
    export default {
        mixins: [SessioMixin],
        data() {
            return {
                name: 'Forum Details',
                link_url: '',
                commentLimit: 3,
                limit: 3,
                offset: 0,
                questionData: [],
                questionCommentData: [],
                addNewComment: false,
                userComment: '',
                userCommentError: '',
                totalComments: 0,
                questionId: 0,
            }
        },
        beforeMount: function () {
            self = this;
            self.questionData['id'] = 0;
        },
        watch: {
            '$route'(to, from) {
                self.link_url = this.$route.params.slug;
                self.$nextTick(function () {
                    self.getQuestionData(self.link_url);
                });
            },
            userComment: function (userComment) {
                if (userComment.length > 0) {
                    self.userCommentError = '';
                }
            },
        },
        mounted: function () {
            $("#alertError").hide();
            self.link_url = this.$route.params.slug;
            self.clickQuestions(self.link_url);
            self.getQuestionData(self.link_url);
        },
        methods: {
            buttonBack() {
                self.$router.push('/forum');
            },
            clickAddNewComment() {
                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {
                    self.addNewComment = (self.addNewComment) ? false : true;
                    self.userComment = "";
                } else {
                    self.checkLogin(window.location.href);
                }
            },
            checkAnswerForm: function () {
                var checked = true;
                self.userCommentError = "";
                if (!self.userComment) {
                    self.userCommentError = "Comment Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addComment(questionId) {
                if (self.checkAnswerForm()) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    };
                    var data = {
                        question_id: questionId,
                        comment: self.userComment,
                    };
                    $("#addComment").html("Submitting ...");
                    $("#CancelComment, #addComment").prop("disabled", true);
                    HTTP.post("addupdatecomment", data, config)
                            .then(function (response) {
                                $("#addComment").html("Submit");
                                $("#addComment").prop("disabled", false);
                                $("#CancelComment").prop("disabled", false);

                                if (response.data.code == 200) {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html("Comment is added successfully.");
                                    /*console.log("if");*/
                                    $("#alertError").show();
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    self.addNewComment = false;
                                    self.userComment = '';
                                    self.userCommentError = '';
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        $("#alertError").hide();
                                        //self.buttonBack();
                                    }, 5000);
                                    self.getQuestionData(self.link_url);
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        $("#alertError").hide();
                                    }, 5000);
                                }
                            })
                            .catch(function (err) {
                                $("#addComment").html("Submit");
                                $("#addComment").prop("disabled", false);
                                $("#CancelComment").prop("disabled", false);
                                $("#errorMsg").html(err.response.data.message);
                                $(".alert-danger").removeClass("hide");
                                $(".alert-danger").addClass("show");
                                $("#alertError").show();
                                setTimeout(function () {
                                    $(".alert-danger").removeClass("show");
                                    $(".alert-danger").addClass("hide");
                                    $("#alertError").hide();
                                }, 5000);

                                if (err.response.status == 0) {
                                    self.errorMsg = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    $("#errorMsg").html(err.response.data.message);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    $("#alertError").show();
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        $("#alertError").hide();
                                    }, 5000);
                                }
                            });
                }
            },
            clickQuestions(questionSlug) {
                var userObj = localStorage.getItem("user_obj");
                var userId = 0;
                if (userObj != null) {
                    var userJson = JSON.parse(userObj);
                    userId = userJson["id"];
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                var fields = {
                    slug: questionSlug,
                    user_id: userId,
                };
                HTTP.post("clickquestion", fields, config)
                        .then(function (response) {
                            if (response.data.code == 200) {
                                //self.$router.push("/forum/" + questionSlug);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            getQuestionData: function (link_url) {
                link_url = (link_url === null || typeof (link_url) === "undefined" || link_url == '') ? '' : link_url;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        slug: link_url,
                        limit: self.limit,
                        comment_limit: self.commentLimit,
                        offset: self.offset,
                        sort: 'created_at',
                    }
                };
                HTTP.get("getquestiondetails", config)
                        .then(function (response) {
                            if (response.data.code == 200) {
                                self.questionData = response.data.content.question;
                                self.questionId = response.data.content.question.id;
                                self.questionCommentData = response.data.content.question.comments;
                                self.totalComments = response.data.content.question.total_comments;
                                setTimeout(function () {
                                    jQuery("a[rel^='prettyPhoto']").prettyPhoto();
                                }, 500);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('api_token');
                                    self.$router.push("/login");
                                }
                            }
                        });
            },
            getComments(questionId) {
                let limit = 3;
                let offset = 3;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        limit: limit,
                        offset: offset,
                        question_id: questionId,
                        sort: 'created_at',
                    }
                };
                HTTP.get("getquestioncommments", config)
                        .then(function (response) {
                            if (response.data.code == 200) {
                                $.each(response.data.content.comments, function (j) {
                                    self.questionCommentData.push(response.data.content.comments[j]);
                                });
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ForumDetails.vue